import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../../config";
import axios from "../../api/axios";

const cookies = new Cookies();

const useReadWithGet = ({ url, initialData, onSuccess, onError, method }) => {
  const [paramsObject, setGetListParams] = useState(initialData);

  // Use React Query's useQuery to fetch data
  const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
    refetchOnWindowFocus: false,
    onSuccess(data) {
      onSuccess?.(data);
    },
    onError(err) {
      onError?.(err);
    },
  });

  const getUsers = async (paramsObject) => {
    let token = cookies.get(TOKEN_NAME);
    const company_id = cookies.get(COMPANY_ID);

    if (method === "GET") {
      // For GET, send company_id in query parameters
      const response = await axios.get(`/${url}`, {
        params: { ...paramsObject, company_id, product_slug: PRODUCT_SLUG }, // Send company_id and product_slug in query params
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      return response.data;
    } else {
      // For POST or other methods, send company_id in FormData
      let fd = new FormData();
      fd.append("company_id", company_id);
      fd.append("product_slug", PRODUCT_SLUG);

      for (let key in paramsObject) {
        fd.append(key, paramsObject[key]);
      }

      const response = await axios({
        method: method || "POST",
        url: `/${url}`,
        data: fd,
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      return response.data;
    }
  };

  return { list, paramsObject, setGetListParams };
};

export default useReadWithGet;
